export default __webpack_public_path__ + "static/media/landing_page_bim_query.96e1739d.gif";